import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";

export const useGetAllPaymentGatewaysServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const allPaymentGatewaysServices = useQuery({
    queryKey: [CACHE_KEYS.PAYMENT_GATEWAYS, page, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PAYMENT_GATEWAYS,
        searchParams: {
          page,
          per_page,
          enableQuery,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allPaymentGatewaysServices },
  };
};
